import { drag, select } from "d3";
import { RefObject, useEffect, useState } from "react";

import { DragDivElement } from "../../../types";

const MINIMUM_HEIGHT = 250;
interface UseResizeLineProps {
  ref: RefObject<HTMLDivElement>;
}

export const useResizeLine = ({ ref }: UseResizeLineProps) => {
  const [animationWindowHeight, setAnimationWindowHeight] = useState<number>(MINIMUM_HEIGHT);
  const [persistantHeight, setPersistantHeight] = useState<number>(animationWindowHeight);

  useEffect(() => {
    const lineElement = ref.current;

    if (lineElement) {
      let startY: number;

      select<HTMLDivElement, null>(lineElement).call(
        drag<HTMLDivElement, null>()
          .on("start", (event: DragDivElement) => {
            const { y } = event;
            startY = y;
          })
          .on("drag", (event: DragDivElement) => {
            const { y } = event;
            const height = Math.max(MINIMUM_HEIGHT, persistantHeight + (startY - y));
            setAnimationWindowHeight(height);
          })
          .on("end", (event: DragDivElement) => {
            const { y } = event;
            setPersistantHeight((prevState) => Math.max(prevState + (startY - y), MINIMUM_HEIGHT));
          })
      );
    }

    return () => {
      if (lineElement) select<HTMLDivElement, null>(lineElement).on("mousedown.drag", null);
    };
  }, [ref, persistantHeight]);

  return { animationWindowHeight };
};
